export const SPRAY_SUBMISSION_SET = 'SPRAY_SUBMISSION_SET';

export const SPRAY_SUBMISSION_SUBMIT_REQUESTED =
    'SPRAY_SUBMISSION_SUBMIT_REQUESTED';
export const SPRAY_SUBMISSION_SUBMIT_SUCCEEDED =
    'SPRAY_SUBMISSION_SUBMIT_SUCCEEDED';
export const SPRAY_SUBMISSION_SUBMIT_FAILED = 'SPRAY_SUBMISSION_SUBMIT_FAILED';

export const SPRAY_SUBMISSION_LOAD_REQUESTED =
    'SPRAY_SUBMISSION_LOAD_REQUESTED';
export const SPRAY_SUBMISSION_LOAD_SUCCEEDED =
    'SPRAY_SUBMISSION_LOAD_SUCCEEDED';
export const SPRAY_SUBMISSION_LOAD_FAILED = 'SPRAY_SUBMISSION_LOAD_FAILED';
export const SPRAY_SUBMISSION_LOAD_CANCELED = 'SPRAY_SUBMISSION_LOAD_CANCELED';

export const SPRAY_SUBMISSION_SUBMIT_NAMESPACE = 'SPRAY_SUBMISSION_SUBMIT';
export const SPRAY_SUBMISSION_LOAD_NAMESPACE = 'SPRAY_SUBMISSION_LOAD';
